import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IProduct } from '@app/model/contract/product.contract';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { CART_GROUP_TYPE_PRODUCT, CartItem, CartSampling, SupplyItem, TestItem } from '@app/model/cart.model';
import * as fromCart from '@app/store/cart/cart.reducers';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromApp from '@app/store/app.reducers';
import { Location } from '@angular/common';
import * as CartActions from '@app/store/cart/cart.actions';
import { withLatestFrom } from 'rxjs/operators';
import { environment } from '@env/environment';
import { CatalogueItem } from '@app/model/catalogue-category/catalogue-item.model';
import { AnalyticalTest } from '@app/model/analytical-test/analytical-test.model';
import { getCartGroupType } from '@app/store/cart/cart.reducers.utils';

@Component({
    selector: 'app-sampling-supply-detail',
    templateUrl: './sampling-supply-detail.component.html',
    styleUrls: ['./sampling-supply-detail.component.scss']
})
export class SamplingSupplyDetailComponent implements OnInit, OnDestroy {

    @Input() inputCatalogueItem: IProduct;
    @Input() container: 'dialog' | 'page' = 'page';
    @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();

    storeSubscription: Subscription;
    catalogueItem: IProduct;
    orderTotal: number;
    isItemInCart$ = new BehaviorSubject(false);
    cartItem: CartItem;
    cartItem$ = new BehaviorSubject<CartItem>(null);
    addingItemToCart$: Observable<boolean>;
    cart: Observable<fromCart.State>;
    currentQuantity: number;
    imageUrl: string;
    cartSampling: CartSampling;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private store: Store<fromApp.AppState>,
        private location: Location) {
    }

    ngOnInit() {
        this.catalogueItem = this.inputCatalogueItem;
        this.subscribeToCart();
        this.addingItemToCart$ = this.store.select(fromApp.getIsAddingItemToCart);
    }

    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }

    quantityChanged(updatedQuantity) {
        this.orderTotal = updatedQuantity * this.catalogueItem.price.amount;
        this.currentQuantity = updatedQuantity;
    }

    addItemToCart() {
    // As creationInstant value set to null as its not used while making service calls.
    // const latestCartItem = new CartItem(this.catalogueItem, this.currentQuantity, this.catalogueItem.price, null);
        const latestCartItem = createCartItem(this.catalogueItem, this.currentQuantity, this.catalogueItem.price);
        if (!this.isItemInCart$.value) {
            this.store.dispatch(new CartActions.AddCartItem(latestCartItem, this.cartSampling));
        } else {
            this.store.dispatch(new CartActions.UpdateCartItem(latestCartItem, this.cartSampling));
        }
    }

    toLastVisitedPage() {
        if (isInDialog(this.container)) {
            this.closeDialog.emit(true);
        } else {
            this.location.back();
        }
    }

    subscribeToCart() {
        this.storeSubscription = this.store.select(fromApp.getCartGroups).pipe(
            withLatestFrom(this.store.select(fromApp.getSamplingSuppliesSampling)))
            .subscribe(
                ([groups, sampling]) => {
                    let cartItem = null;
                    this.cartSampling = sampling;

                    if ((groups && sampling && sampling.groupId && groups.length > 0)) {
                        const samplingItemsGroup = groups.filter(
                            group => getCartGroupType(group.resourceType) === CART_GROUP_TYPE_PRODUCT);
                        if (samplingItemsGroup.length > 0) {
                            const items = samplingItemsGroup[0].items;
                            cartItem = items.filter(i => i.item.id === this.catalogueItem.id)[0];
                        }
                    }

                    if (cartItem != null) {
                        this.isItemInCart$.next(true);
                        this.currentQuantity = cartItem.quantity;
                        this.cartItem = cartItem;

                    } else {
                        this.currentQuantity = 1;
                        this.cartItem = createCartItem(this.catalogueItem, 1, this.catalogueItem.price);
                        this.isItemInCart$.next(false);
                    }

                    this.cartItem$.next(this.cartItem);

                    this.orderTotal = this.currentQuantity * this.catalogueItem.price.amount;
                    this.imageUrl = environment.cdnCatalogueImageUrl + environment.cdn300x300Images
          + this.catalogueItem.id + '.jpg';
                }
            );
    }

    isSampling(item) {
        return item instanceof CatalogueItem;
    }
}

export const createCartItem = (item: IProduct, qty, price) => {
    if (item instanceof AnalyticalTest) {
        return new TestItem(item, null);
    }
    return new SupplyItem(item, qty, price, null);
};

const isInDialog = (container: 'dialog' | 'page') => container === 'dialog';
